/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../context/Customer/GraphQL/ForgotPassword.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CartLedgerFragment = {
  readonly __typename?: 'Ledger';
  readonly tax: number;
  readonly subtotal: number;
  readonly feesTotal: number;
  readonly discountsTotal: number;
  readonly creditsTotal: number;
  readonly tip: number;
  readonly discounts: ReadonlyArray<{
    readonly __typename?: 'LedgerItem';
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly credits: ReadonlyArray<{
    readonly __typename?: 'LedgerItem';
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly fees: ReadonlyArray<{
    readonly __typename?: 'LedgerItem';
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
};

export type CartLineItemFragment = {
  readonly __typename?: 'LineItem';
  readonly id: string;
  readonly slug: string;
  readonly quantity: number;
  readonly cost: number;
  readonly customName: string | null;
  readonly perItemCost: number;
  readonly favorited: boolean;
  readonly isCustom: boolean;
  readonly dressingMode: Types.DressingMode;
  readonly addedIngredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly removedIngredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly product: {
    readonly __typename?: 'Product';
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly isCustom: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
  };
  readonly mixedDressingDetails: ReadonlyArray<{
    readonly __typename?: 'MixedDressingDetails';
    readonly ingredientId: string;
    readonly weight: Types.DressingWeight;
  }>;
};

export type CartRestaurantFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly city: string;
  readonly state: string;
  readonly address: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly deliveryMinSubtotal: number;
  readonly availableDropOffLocations: ReadonlyArray<{
    readonly __typename?: 'DropOffLocation';
    readonly id: string;
    readonly name: string;
  }>;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
};

export type AvailableWantedTimeFragment = {
  readonly __typename?: 'AvailableWantedTime';
  readonly time: string;
};

export type DeliveryOrderDetailFragment = {
  readonly __typename?: 'DeliveryOrderDetail';
  readonly id: string;
  readonly tip: number;
  readonly deliveryFee: number;
  readonly vendor: string;
  readonly orderId: string;
  readonly vendorRestaurantId: string;
  readonly estimatedDeliveryTime: string | null;
  readonly address: {
    readonly __typename?: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  };
};

export type CartDataFragment = {
  readonly __typename?: 'Order';
  readonly id: string;
  readonly orderType: Types.OrderType;
  readonly ledger: {
    readonly __typename?: 'Ledger';
    readonly tax: number;
    readonly subtotal: number;
    readonly feesTotal: number;
    readonly discountsTotal: number;
    readonly creditsTotal: number;
    readonly tip: number;
    readonly discounts: ReadonlyArray<{
      readonly __typename?: 'LedgerItem';
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'LedgerItem';
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
    readonly fees: ReadonlyArray<{
      readonly __typename?: 'LedgerItem';
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
  };
  readonly lineItems: ReadonlyArray<{
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly slug: string;
    readonly quantity: number;
    readonly cost: number;
    readonly customName: string | null;
    readonly perItemCost: number;
    readonly favorited: boolean;
    readonly isCustom: boolean;
    readonly dressingMode: Types.DressingMode;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly isCustom: boolean;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly ingredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
      }>;
    };
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly __typename?: 'MixedDressingDetails';
      readonly ingredientId: string;
      readonly weight: Types.DressingWeight;
    }>;
  }>;
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly city: string;
    readonly state: string;
    readonly address: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly deliveryMinSubtotal: number;
    readonly availableDropOffLocations: ReadonlyArray<{
      readonly __typename?: 'DropOffLocation';
      readonly id: string;
      readonly name: string;
    }>;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  };
  readonly availableWantedTimes: ReadonlyArray<{
    readonly __typename?: 'AvailableWantedTime';
    readonly time: string;
  }>;
  readonly deliveryOrderDetail: {
    readonly __typename?: 'DeliveryOrderDetail';
    readonly id: string;
    readonly tip: number;
    readonly deliveryFee: number;
    readonly vendor: string;
    readonly orderId: string;
    readonly vendorRestaurantId: string;
    readonly estimatedDeliveryTime: string | null;
    readonly address: {
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly city: string;
      readonly state: string;
      readonly country: string;
      readonly zipCode: string;
      readonly deliveryPreference: Types.DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly name: string | null;
      readonly notes: string | null;
    };
  } | null;
};

export type CartQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CartQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  } | null;
};

export type AddLineItemToCartSuccessFieldsFragment = {
  readonly __typename?: 'AddLineItemToCartSuccess';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type EditLineItemInCartSuccessFieldsFragment = {
  readonly __typename?: 'EditLineItemInCartSuccess';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type RemoveFromCartSuccessFieldsFragment = {
  readonly __typename?: 'RemoveFromCartSuccess';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type RestaurantMaxQuantityExceededFieldsFragment = {
  readonly __typename?: 'RestaurantMaxQuantityExceeded';
  readonly message: string;
  readonly status: number;
};

export type MaxModificationsExceededFieldsFragment = {
  readonly __typename?: 'MaxModificationsExceeded';
  readonly message: string;
  readonly status: number;
};

export type RestaurantMaxDeliveryQuantityExceededFieldsFragment = {
  readonly __typename?: 'RestaurantMaxDeliveryQuantityExceeded';
  readonly message: string;
  readonly status: number;
};

export type ProductOutOfStockFieldsFragment = {
  readonly __typename?: 'ProductOutOfStock';
  readonly message: string;
  readonly status: number;
};

export type AddLineItemToCartMutationVariables = Types.Exact<{
  input: Types.AddLineItemToCartInput;
}>;

export type AddLineItemToCartMutation = {
  readonly __typename?: 'Mutation';
  readonly addLineItemToCart:
    | {
        readonly __typename: 'AddLineItemToCartSuccess';
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ProductOutOfStock';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type EditLineItemInCartMutationVariables = Types.Exact<{
  input: Types.EditLineItemInCartInput;
}>;

export type EditLineItemInCartMutation = {
  readonly __typename?: 'Mutation';
  readonly editLineItemInCart:
    | {
        readonly __typename: 'EditLineItemInCartSuccess';
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type RemoveFromCartMutationVariables = Types.Exact<{
  input: Types.RemoveFromCartInput;
}>;

export type RemoveFromCartMutation = {
  readonly __typename?: 'Mutation';
  readonly removeFromCart:
    | {
        readonly __typename: 'RemoveFromCartSuccess';
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const cartQueryMock: ExecutionResult<CartQuery> = {
  data: {
    cart: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      orderType: 'DELIVERY',
      ledger: {
        tax: 4,
        subtotal: 65,
        feesTotal: 38,
        discountsTotal: -10,
        creditsTotal: 28,
        tip: -12,
        discounts: [
          { name: 'Hello World', amount: -17, description: 'Hello World' },
        ],
        credits: [
          { name: 'Hello World', amount: 43, description: 'Hello World' },
        ],
        fees: [
          { name: 'Hello World', amount: -7, description: 'Hello World' },
          { name: 'Hello World', amount: 79, description: 'Hello World' },
          { name: 'Hello World', amount: 68, description: 'Hello World' },
        ],
      },
      lineItems: [
        {
          id: '96e8a185-e3da-400a-9a47-534319d08060',
          slug: 'b59aa250-f9c4-4016-b1bd-634cb273b7f9',
          quantity: 90,
          cost: -83,
          customName: 'Hello World',
          perItemCost: 7,
          favorited: true,
          isCustom: false,
          addedIngredients: [
            {
              id: '0f1b1f2c-49f5-4fd7-994c-cdcab38b7485',
              name: 'Hello World',
              kind: 'BASE',
              asset: { url: 'Hello World' },
            },
          ],
          removedIngredients: [
            {
              id: 'fbe88532-ede7-4a1d-aa93-3e0e095a7b48',
              name: 'Hello World',
              kind: 'BASE',
              asset: { url: 'Hello World' },
            },
            {
              id: 'f0bb560d-0180-4d39-8a0c-0520a352a4a6',
              name: 'Hello World',
              kind: 'BASE',
              asset: { url: 'Hello World' },
            },
          ],
          product: {
            id: '541b5bc5-d089-4f52-a921-d91bfdfbabd3',
            name: 'Hello World',
            slug: 'Hello World',
            isCustom: true,
            asset: { url: 'Hello World' },
            ingredients: [
              {
                id: 'df8eb150-587b-4384-8482-99be511f9b1e',
                name: 'Hello World',
                kind: 'BASE',
              },
              {
                id: '39b6d74a-fbe5-42f8-a3a6-f32f0edaef12',
                name: 'Hello World',
                kind: 'BASE',
              },
              {
                id: '2810af29-1521-4b27-b2ba-dd9c8f96f010',
                name: 'Hello World',
                kind: 'BASE',
              },
            ],
          },
          mixedDressingDetails: [
            {
              ingredientId: 'a1539642-9788-4b39-8138-d5004934e080',
              weight: 'HEAVY',
            },
            {
              ingredientId: 'ad7fd625-14dd-494f-b6b4-1c23d4c4b96c',
              weight: 'HEAVY',
            },
            {
              ingredientId: 'aa8622a5-17d3-4cbc-bf05-167a358d451b',
              weight: 'HEAVY',
            },
          ],
          dressingMode: 'MIXED',
        },
        {
          id: '9313663d-b9eb-42f5-97f5-34a27f5acfbd',
          slug: 'a03bfaf7-e27a-459a-b81e-64855fe3c247',
          quantity: -97,
          cost: 74,
          customName: 'Hello World',
          perItemCost: -34,
          favorited: true,
          isCustom: false,
          addedIngredients: [
            {
              id: 'aff27422-c629-4331-a9f0-cff6a9347d88',
              name: 'Hello World',
              kind: 'BASE',
              asset: { url: 'Hello World' },
            },
            {
              id: 'd8eee30f-22b9-444d-a53a-b94c40130766',
              name: 'Hello World',
              kind: 'BASE',
              asset: { url: 'Hello World' },
            },
          ],
          removedIngredients: [
            {
              id: 'c55f9f51-6095-4e6e-9edc-961aaeec36e4',
              name: 'Hello World',
              kind: 'BASE',
              asset: { url: 'Hello World' },
            },
          ],
          product: {
            id: '0545d8c2-54bf-4a75-9135-291a95511cba',
            name: 'Hello World',
            slug: 'Hello World',
            isCustom: true,
            asset: { url: 'Hello World' },
            ingredients: [
              {
                id: 'e171218c-ef4b-43e4-8fb0-e31ab26ed5bc',
                name: 'Hello World',
                kind: 'BASE',
              },
            ],
          },
          mixedDressingDetails: [
            {
              ingredientId: 'c8c1e299-d203-4485-b385-b5d1d6c3a3f0',
              weight: 'HEAVY',
            },
          ],
          dressingMode: 'MIXED',
        },
      ],
      restaurant: {
        id: '28c5aed6-3622-4b16-a685-446f42ce3174',
        slug: 'Hello World',
        name: 'Hello World',
        city: 'Hello World',
        state: 'Hello World',
        address: 'Hello World',
        zipCode: 'Hello World',
        isOutpost: false,
        deliveryMinSubtotal: 58.28,
        availableDropOffLocations: [
          { id: 'd1bce911-301d-43f8-80a7-ac54fdbbcdd3', name: 'Hello World' },
          { id: '501c158b-2135-4e52-a78d-34f8c519c93f', name: 'Hello World' },
        ],
        asset: { url: 'Hello World' },
      },
      availableWantedTimes: [
        { time: 'Hello World' },
        { time: 'Hello World' },
        { time: 'Hello World' },
      ],
      deliveryOrderDetail: {
        id: '53938fda-43a0-4d98-8380-a5f9c5deb883',
        tip: -25.25,
        deliveryFee: -96.63,
        vendor: 'Hello World',
        orderId: '1cde56c3-7eab-4d31-94e1-c28c83a196f2',
        vendorRestaurantId: 'Hello World',
        estimatedDeliveryTime: 'Hello World',
        address: {
          id: '05d87fd3-323c-43c4-878f-e96f0fc6c7c7',
          street: 'Hello World',
          secondaryStreet: 'Hello World',
          city: 'Hello World',
          state: 'Hello World',
          country: 'Hello World',
          zipCode: 'Hello World',
          deliveryPreference: 'CURBSIDE',
          googlePlaceId: 'Hello World',
          latitude: 80.13,
          longitude: 89.63,
          name: 'Hello World',
          notes: 'Hello World',
        },
      },
    },
  },
};

export const addLineItemToCartMutationMock: ExecutionResult<AddLineItemToCartMutation> =
  {
    data: {
      addLineItemToCart: {
        __typename: 'AddLineItemToCartSuccess',
        cart: {
          id: '3fd67f29-d940-4ac3-a65d-867d828cb8f2',
          orderType: 'DELIVERY',
          ledger: {
            tax: -28,
            subtotal: -62,
            feesTotal: -59,
            discountsTotal: 36,
            creditsTotal: 25,
            tip: 66,
            discounts: [
              { name: 'Hello World', amount: -17, description: 'Hello World' },
              { name: 'Hello World', amount: -78, description: 'Hello World' },
              { name: 'Hello World', amount: -82, description: 'Hello World' },
            ],
            credits: [
              { name: 'Hello World', amount: 52, description: 'Hello World' },
            ],
            fees: [
              { name: 'Hello World', amount: -23, description: 'Hello World' },
            ],
          },
          lineItems: [
            {
              id: '72b99b38-d436-41b5-9e69-718e59992088',
              slug: 'fef6ff29-8329-4a3f-bd32-4a9355665b63',
              quantity: -99,
              cost: 86,
              customName: 'Hello World',
              perItemCost: 17,
              favorited: false,
              isCustom: false,
              addedIngredients: [
                {
                  id: '6584a270-2158-4979-9ae4-67d6e8a1a754',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: '72c49516-9c3a-4632-a675-2ccbff5c458d',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: '24c5a557-cfc0-4919-83ad-57978158278f',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: false,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: '7f3a6b1e-15eb-4c61-83a3-c73ebe8d8e2b',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: '4a3ae596-dfca-4ff7-a4b7-bcfdb158b5bd',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: 'c86fa51d-c9c3-47e8-a8bb-d3352e54c6a5',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '73924456-bf26-474a-827c-c2de5b8ad638',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
            {
              id: 'aeaed1f8-f9d6-4b99-82b6-2cbf4f5f777a',
              slug: 'a9c9114c-0228-4083-acd3-61682050a44d',
              quantity: -7,
              cost: 19,
              customName: 'Hello World',
              perItemCost: 10,
              favorited: false,
              isCustom: true,
              addedIngredients: [
                {
                  id: 'b9a6119b-2f35-4577-9adf-bda971c35e72',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: 'e8d81ed1-b6c1-4676-bc15-e63cccbd60b7',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: '9cfc9748-fdd6-4fe2-8ae0-0f99b4af482d',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: 'd91fbdb3-4aad-46fd-a80e-53b581470a07',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: '4e576e15-62b9-4e11-8b9a-e21f0b5fb84f',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: true,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: 'b15b7b52-a37f-4d8c-9453-17cdcdf5537c',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: 'b43cf3ee-cf00-4cab-b1e4-500691606029',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: 'c6de552f-dbd0-4634-b156-d8b7c4fad52f',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: 'e2e30886-2596-49d4-9d7f-41daf0c5fc75',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '67d5e430-bdeb-4aad-8af6-9485f94c6610',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: 'b72ad745-49be-4dcc-8840-0665d3b30720',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
            {
              id: 'ccde8c32-eb53-46ee-8738-a06a9bdc3a63',
              slug: '4412cf3a-e82b-4a7c-b47a-0508daaee6de',
              quantity: 48,
              cost: -53,
              customName: 'Hello World',
              perItemCost: 31,
              favorited: false,
              isCustom: true,
              addedIngredients: [
                {
                  id: 'cd15dd6d-90db-4fa1-9eb5-0cd79bb86ae8',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: 'c719c7f8-3f58-4727-9d34-48eac74ae93b',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: '994d553f-ad9f-4cb0-9d95-065545cdf164',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: 'd7797b58-c18f-42c4-a02c-6baebd9682e4',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: 'ff5ff37e-22bd-4d29-a9c2-77b89bed1e1a',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: 'aad7551e-7d32-4410-bb9c-68cb543171b3',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: false,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: 'a3681ac2-3db0-4c90-910f-cf2249125073',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: 'ae22a90b-9ea5-4880-8b11-8f5355b28934',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '996a0fe8-f18c-453b-a0a6-28f79750cd1b',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '7b4bd610-1cb0-47e1-a9e7-33b09bee5a9a',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
          ],
          restaurant: {
            id: 'ec7ce009-df85-45ad-82df-7320d872d4d5',
            slug: 'Hello World',
            name: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            address: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            deliveryMinSubtotal: -67.09,
            availableDropOffLocations: [
              {
                id: '00d83169-8473-4430-b8eb-fd80a7d71d67',
                name: 'Hello World',
              },
              {
                id: '276ef1a6-939e-449f-ac8f-013495f22f9c',
                name: 'Hello World',
              },
            ],
            asset: { url: 'Hello World' },
          },
          availableWantedTimes: [
            { time: 'Hello World' },
            { time: 'Hello World' },
            { time: 'Hello World' },
          ],
          deliveryOrderDetail: {
            id: '01f87b04-a506-4b85-93dc-6770176a632e',
            tip: -41.85,
            deliveryFee: -14.91,
            vendor: 'Hello World',
            orderId: '3510d767-c538-4cf0-b429-cb98ef477f20',
            vendorRestaurantId: 'Hello World',
            estimatedDeliveryTime: 'Hello World',
            address: {
              id: 'fe7ae24b-b9c8-4c30-9d96-ab29962f0ca0',
              street: 'Hello World',
              secondaryStreet: 'Hello World',
              city: 'Hello World',
              state: 'Hello World',
              country: 'Hello World',
              zipCode: 'Hello World',
              deliveryPreference: 'CURBSIDE',
              googlePlaceId: 'Hello World',
              latitude: -78.9,
              longitude: 90.6,
              name: 'Hello World',
              notes: 'Hello World',
            },
          },
        },
      },
    },
  };

export const editLineItemInCartMutationMock: ExecutionResult<EditLineItemInCartMutation> =
  {
    data: {
      editLineItemInCart: {
        __typename: 'EditLineItemInCartSuccess',
        cart: {
          id: 'e9f465e8-1ee5-4d3f-b8a9-8f0762ae5011',
          orderType: 'DELIVERY',
          ledger: {
            tax: -95,
            subtotal: -55,
            feesTotal: -17,
            discountsTotal: -57,
            creditsTotal: 94,
            tip: 53,
            discounts: [
              { name: 'Hello World', amount: -77, description: 'Hello World' },
              { name: 'Hello World', amount: -55, description: 'Hello World' },
              { name: 'Hello World', amount: 42, description: 'Hello World' },
            ],
            credits: [
              { name: 'Hello World', amount: -31, description: 'Hello World' },
              { name: 'Hello World', amount: -51, description: 'Hello World' },
              { name: 'Hello World', amount: -2, description: 'Hello World' },
            ],
            fees: [
              { name: 'Hello World', amount: -9, description: 'Hello World' },
              { name: 'Hello World', amount: -79, description: 'Hello World' },
            ],
          },
          lineItems: [
            {
              id: '619d6402-bf75-45bd-a2d7-ba12ca425c5a',
              slug: '535e5227-82d8-471c-b906-1c6fb0e86ae7',
              quantity: -88,
              cost: 70,
              customName: 'Hello World',
              perItemCost: 36,
              favorited: false,
              isCustom: false,
              addedIngredients: [
                {
                  id: 'ce239b58-f913-4e41-b1f2-3b0e4180fc8c',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: '5652bfbd-4851-4bf2-b8b3-ad4bcca2a19a',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: '86dd56a2-7527-4804-a6f0-f2250987c4a8',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: 'dce310b8-ebe6-48ad-815f-3ca7c9871219',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: '26b26e23-48db-47aa-b832-beba3e91a3f7',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: false,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: '2238bec4-5858-464f-a793-6d113c9910a0',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: '4dba13c4-a3a8-483b-be58-1d88513c6c35',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: '143a9960-2e5f-4e56-ac3b-24aa6ac094b6',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: '3ef9c240-b170-4cd7-bffd-687864c7a288',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: 'bb4dace7-fb9b-42af-9ef4-92abc7983ecb',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
            {
              id: '7c0bca1b-061a-4b18-8e8e-f69cb6bdc066',
              slug: '242e6302-852f-469a-b05a-bc203ab4b19e',
              quantity: 85,
              cost: 33,
              customName: 'Hello World',
              perItemCost: -97,
              favorited: false,
              isCustom: false,
              addedIngredients: [
                {
                  id: '8a542ac8-251c-47a1-9302-c89cb0b2c3f9',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: '4039a015-da09-4fe4-9097-b01818ea39cb',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: '7a464f29-9e2d-47b1-98bd-66224cc261ba',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: '043d913a-07ee-4bfb-997c-471ae07efe42',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: false,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: '6f0ee643-976a-43a6-80ad-bf4faa80e339',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: '5a63d1d6-fb1c-4cf4-a503-4ef3b86ef583',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: '941f446a-2c05-4032-a5cc-30b1a9de02c9',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '44129a25-9574-40c1-b08a-5c0de9ab2579',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '20b7caad-6f0b-4748-b4df-13a5d9d1fd3d',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
          ],
          restaurant: {
            id: '410d7c28-bfc3-408e-b8f9-6963815039e7',
            slug: 'Hello World',
            name: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            address: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: false,
            deliveryMinSubtotal: -32.46,
            availableDropOffLocations: [
              {
                id: 'e6938789-58e4-45ba-8a3f-4331f220c2a8',
                name: 'Hello World',
              },
              {
                id: 'b10817f9-7251-4ee7-aa86-e66de2ec207f',
                name: 'Hello World',
              },
              {
                id: 'f743fc1f-1a6c-4e2e-a093-472d8e97f0cb',
                name: 'Hello World',
              },
            ],
            asset: { url: 'Hello World' },
          },
          availableWantedTimes: [{ time: 'Hello World' }],
          deliveryOrderDetail: {
            id: '296af506-2860-45ed-807b-0fdc71a8f708',
            tip: -61.73,
            deliveryFee: 48.59,
            vendor: 'Hello World',
            orderId: 'ff4468fd-fe13-414b-a444-aac2a528cb26',
            vendorRestaurantId: 'Hello World',
            estimatedDeliveryTime: 'Hello World',
            address: {
              id: 'f324dd05-a203-4243-a6a3-16585ba569a8',
              street: 'Hello World',
              secondaryStreet: 'Hello World',
              city: 'Hello World',
              state: 'Hello World',
              country: 'Hello World',
              zipCode: 'Hello World',
              deliveryPreference: 'CURBSIDE',
              googlePlaceId: 'Hello World',
              latitude: -3.43,
              longitude: 59.65,
              name: 'Hello World',
              notes: 'Hello World',
            },
          },
        },
      },
    },
  };

export const removeFromCartMutationMock: ExecutionResult<RemoveFromCartMutation> =
  {
    data: {
      removeFromCart: {
        __typename: 'RemoveFromCartSuccess',
        cart: {
          id: '7e4e1179-1524-4356-96c8-50130e87f214',
          orderType: 'DELIVERY',
          ledger: {
            tax: -61,
            subtotal: -42,
            feesTotal: 72,
            discountsTotal: -58,
            creditsTotal: 31,
            tip: -44,
            discounts: [
              { name: 'Hello World', amount: 78, description: 'Hello World' },
            ],
            credits: [
              { name: 'Hello World', amount: -6, description: 'Hello World' },
              { name: 'Hello World', amount: 57, description: 'Hello World' },
            ],
            fees: [
              { name: 'Hello World', amount: -14, description: 'Hello World' },
              { name: 'Hello World', amount: -86, description: 'Hello World' },
            ],
          },
          lineItems: [
            {
              id: '27d143f7-6039-4085-a3a1-af0791366cbc',
              slug: '768fac8f-3a4b-4917-bc33-3700d888a916',
              quantity: 49,
              cost: -83,
              customName: 'Hello World',
              perItemCost: -38,
              favorited: true,
              isCustom: false,
              addedIngredients: [
                {
                  id: '887d7af6-c127-449a-8f74-c9bf125694d2',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: 'af208840-d15d-425a-b59a-6a959dfc09b4',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: '9fafa940-4028-4308-8f69-4317e70701a8',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: '310b27e5-7272-4642-a522-9aa8f03acaef',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: '036811f8-1fd2-4535-a1ae-c5e4377c342a',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: false,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: '169998a3-ea25-4ffe-bc27-93ee893888cf',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: 'b7a591b3-ccec-4053-8d56-c826854d55f6',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                  {
                    id: '978cb85b-33dc-4a58-a9ca-b76857ae7a26',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: 'ca36268d-d9ff-4121-b903-f9af43a7d908',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: 'bdc5295f-db12-488f-8a7a-6be109991c48',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
            {
              id: 'aecf3a23-dd40-430d-ba22-da7c26f8e647',
              slug: '1266b3cc-8a80-4512-b5c8-7c9bf8e289a7',
              quantity: 40,
              cost: 73,
              customName: 'Hello World',
              perItemCost: 55,
              favorited: true,
              isCustom: true,
              addedIngredients: [
                {
                  id: '0b2f1f0b-c44c-4ab4-9a3c-e7b31c801e4b',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: '5789288c-aaf9-4668-b410-78a3c3c73d63',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: '41293884-af36-4147-a334-fa77bd6cc802',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
                {
                  id: 'af3976bc-bab3-4ee3-a99a-8a983f64659c',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: 'e23e6fee-a38d-418f-91db-3845754d4f0d',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: false,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: 'c103a42b-5bfe-498c-b883-11e73e3449c6',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: 'ba1a3f6f-3c51-4610-970b-868920ab872b',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '6a467455-b867-4dd9-9bb8-04a99365008a',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: '65e26dc3-9f24-4e7c-baaa-0ca84ed240a1',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
            {
              id: '67b208f8-5480-4f52-a260-86fcc73c0e5a',
              slug: '8de29e05-bce8-41d8-9706-4c01468b4de1',
              quantity: -18,
              cost: 20,
              customName: 'Hello World',
              perItemCost: -80,
              favorited: false,
              isCustom: false,
              addedIngredients: [
                {
                  id: 'ecbf25b1-a1d0-42b4-a1c9-604323755426',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              removedIngredients: [
                {
                  id: '7540713d-e57d-44f7-815d-24f75f62ea47',
                  name: 'Hello World',
                  kind: 'BASE',
                  asset: { url: 'Hello World' },
                },
              ],
              product: {
                id: '44b6fcbb-e4dc-437d-bce1-66aa4d5aaa61',
                name: 'Hello World',
                slug: 'Hello World',
                isCustom: true,
                asset: { url: 'Hello World' },
                ingredients: [
                  {
                    id: '037bda40-0d35-480f-ab71-775c1d73f1f5',
                    name: 'Hello World',
                    kind: 'BASE',
                  },
                ],
              },
              mixedDressingDetails: [
                {
                  ingredientId: 'b9533ffe-d33d-4433-884a-068e47fe5fa1',
                  weight: 'HEAVY',
                },
                {
                  ingredientId: 'b60a7a29-0540-4b4c-851b-42e5d1cac03d',
                  weight: 'HEAVY',
                },
              ],
              dressingMode: 'MIXED',
            },
          ],
          restaurant: {
            id: '95afd31a-d58d-49c3-abdd-9914c0320e9c',
            slug: 'Hello World',
            name: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            address: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            deliveryMinSubtotal: 74.32,
            availableDropOffLocations: [
              {
                id: 'a1fff3db-36e0-400e-b7ee-8645483d57bc',
                name: 'Hello World',
              },
              {
                id: '6d1212e4-4ce5-40ac-82b7-247655a65ccd',
                name: 'Hello World',
              },
            ],
            asset: { url: 'Hello World' },
          },
          availableWantedTimes: [{ time: 'Hello World' }],
          deliveryOrderDetail: {
            id: '6e80879c-89ba-4e93-8363-badcfdff0dcf',
            tip: 43.53,
            deliveryFee: -83.23,
            vendor: 'Hello World',
            orderId: '238e141c-b7b5-4dbe-8aaa-4b471eb2bd95',
            vendorRestaurantId: 'Hello World',
            estimatedDeliveryTime: 'Hello World',
            address: {
              id: '07b94fac-3687-4385-8451-d9bfe8a1e162',
              street: 'Hello World',
              secondaryStreet: 'Hello World',
              city: 'Hello World',
              state: 'Hello World',
              country: 'Hello World',
              zipCode: 'Hello World',
              deliveryPreference: 'CURBSIDE',
              googlePlaceId: 'Hello World',
              latitude: -28.45,
              longitude: 40.43,
              name: 'Hello World',
              notes: 'Hello World',
            },
          },
        },
      },
    },
  };
export const CartLedgerFragmentDoc = gql`
  fragment CartLedger on Ledger {
    tax
    subtotal
    feesTotal
    discountsTotal
    creditsTotal
    tip
    discounts {
      name
      amount
      description
    }
    credits {
      name
      amount
      description
    }
    fees {
      name
      amount
      description
    }
  }
`;
export const CartLineItemFragmentDoc = gql`
  fragment CartLineItem on LineItem {
    id
    slug
    quantity
    cost
    customName
    perItemCost
    favorited
    isCustom
    addedIngredients {
      id
      name
      kind
      asset {
        url
      }
    }
    removedIngredients {
      id
      name
      kind
      asset {
        url
      }
    }
    product {
      id
      name
      slug
      isCustom
      asset {
        url
      }
      ingredients {
        id
        name
        kind
      }
    }
    mixedDressingDetails {
      ingredientId
      weight
    }
    dressingMode
  }
`;
export const CartRestaurantFragmentDoc = gql`
  fragment CartRestaurant on Restaurant {
    id
    slug
    name
    city
    state
    address
    zipCode
    isOutpost
    deliveryMinSubtotal
    isOutpost
    availableDropOffLocations {
      id
      name
    }
    asset {
      url
    }
  }
`;
export const AvailableWantedTimeFragmentDoc = gql`
  fragment AvailableWantedTime on AvailableWantedTime {
    time
  }
`;
export const DeliveryOrderDetailFragmentDoc = gql`
  fragment DeliveryOrderDetail on DeliveryOrderDetail {
    id
    tip
    deliveryFee
    vendor
    orderId
    vendorRestaurantId
    estimatedDeliveryTime
    address {
      id
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;
export const CartDataFragmentDoc = gql`
  fragment CartData on Order {
    id
    orderType
    ledger {
      ...CartLedger
    }
    lineItems {
      ...CartLineItem
    }
    restaurant {
      ...CartRestaurant
    }
    availableWantedTimes {
      ...AvailableWantedTime
    }
    deliveryOrderDetail {
      ...DeliveryOrderDetail
    }
  }
  ${CartLedgerFragmentDoc}
  ${CartLineItemFragmentDoc}
  ${CartRestaurantFragmentDoc}
  ${AvailableWantedTimeFragmentDoc}
  ${DeliveryOrderDetailFragmentDoc}
`;
export const AddLineItemToCartSuccessFieldsFragmentDoc = gql`
  fragment AddLineItemToCartSuccessFields on AddLineItemToCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const EditLineItemInCartSuccessFieldsFragmentDoc = gql`
  fragment EditLineItemInCartSuccessFields on EditLineItemInCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const RemoveFromCartSuccessFieldsFragmentDoc = gql`
  fragment RemoveFromCartSuccessFields on RemoveFromCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const RestaurantMaxQuantityExceededFieldsFragmentDoc = gql`
  fragment RestaurantMaxQuantityExceededFields on RestaurantMaxQuantityExceeded {
    message
    status
  }
`;
export const MaxModificationsExceededFieldsFragmentDoc = gql`
  fragment MaxModificationsExceededFields on MaxModificationsExceeded {
    message
    status
  }
`;
export const RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc = gql`
  fragment RestaurantMaxDeliveryQuantityExceededFields on RestaurantMaxDeliveryQuantityExceeded {
    message
    status
  }
`;
export const ProductOutOfStockFieldsFragmentDoc = gql`
  fragment ProductOutOfStockFields on ProductOutOfStock {
    message
    status
  }
`;
export const CartDocument = gql`
  query Cart {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;

export function useCartQuery(
  options?: Omit<Urql.UseQueryArgs<CartQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CartQuery, CartQueryVariables>({
    query: CartDocument,
    ...options,
  });
}
export const AddLineItemToCartDocument = gql`
  mutation AddLineItemToCart($input: AddLineItemToCartInput!) {
    addLineItemToCart(input: $input) {
      __typename
      ...AddLineItemToCartSuccessFields
      ...RestaurantMaxQuantityExceededFields
      ...RestaurantMaxDeliveryQuantityExceededFields
      ...MaxModificationsExceededFields
      ...ValidationErrorFields
      ...ProductOutOfStockFields
    }
  }
  ${AddLineItemToCartSuccessFieldsFragmentDoc}
  ${RestaurantMaxQuantityExceededFieldsFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc}
  ${MaxModificationsExceededFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${ProductOutOfStockFieldsFragmentDoc}
`;

export function useAddLineItemToCartMutation() {
  return Urql.useMutation<
    AddLineItemToCartMutation,
    AddLineItemToCartMutationVariables
  >(AddLineItemToCartDocument);
}
export const EditLineItemInCartDocument = gql`
  mutation EditLineItemInCart($input: EditLineItemInCartInput!) {
    editLineItemInCart(input: $input) {
      __typename
      ...EditLineItemInCartSuccessFields
      ...RestaurantMaxQuantityExceededFields
      ...RestaurantMaxDeliveryQuantityExceededFields
      ...MaxModificationsExceededFields
      ...ValidationErrorFields
    }
  }
  ${EditLineItemInCartSuccessFieldsFragmentDoc}
  ${RestaurantMaxQuantityExceededFieldsFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc}
  ${MaxModificationsExceededFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useEditLineItemInCartMutation() {
  return Urql.useMutation<
    EditLineItemInCartMutation,
    EditLineItemInCartMutationVariables
  >(EditLineItemInCartDocument);
}
export const RemoveFromCartDocument = gql`
  mutation RemoveFromCart($input: RemoveFromCartInput!) {
    removeFromCart(input: $input) {
      __typename
      ...RemoveFromCartSuccessFields
      ...ValidationErrorFields
    }
  }
  ${RemoveFromCartSuccessFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useRemoveFromCartMutation() {
  return Urql.useMutation<
    RemoveFromCartMutation,
    RemoveFromCartMutationVariables
  >(RemoveFromCartDocument);
}
